// BACKEND INTEGRATION POINT: Replace with JWT/session-based vendor authentication.
// This in-memory store is for prototype demo only.

import { Vendor } from './mockData';

let currentVendor: Vendor | null = null;

export function setCurrentVendor(vendor: Vendor) {
  currentVendor = vendor;
  if (typeof window !== 'undefined') {
    sessionStorage.setItem('vendorgrn_vendor', JSON.stringify(vendor));
  }
}

export function getCurrentVendor(): Vendor | null {
  if (currentVendor) return currentVendor;
  if (typeof window !== 'undefined') {
    const stored = sessionStorage.getItem('vendorgrn_vendor');
    if (stored) {
      try {
        currentVendor = JSON.parse(stored) as Vendor;
        return currentVendor;
      } catch {
        return null;
      }
    }
  }
  return null;
}

export function clearCurrentVendor() {
  currentVendor = null;
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem('vendorgrn_vendor');
    sessionStorage.removeItem('vendorgrn_selected_po');
  }
}

export function setSelectedPO(poId: string) {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem('vendorgrn_selected_po', poId);
  }
}

export function getSelectedPO(): string | null {
  if (typeof window !== 'undefined') {
    return sessionStorage.getItem('vendorgrn_selected_po');
  }
  return null;
}
export { Vendor };